let audio;

export function playNotificationSound() {
  try {
    if (!audio) {
      audio = new Audio("/sound/notify.wav");
      audio.volume = 1; // adjust volume (0 to 1)
    }
    audio.currentTime = 0;
    audio.play().catch(() => {});
  } catch (e) {
    console.warn("Notification sound failed:", e);
  }
}
